import axios from 'axios';
import url from 'url'

const proxy = new url.parse(process.env.REACT_APP_QUOTAGUARDSTATIC_URL);

export async function apiGetCall(apiUrl) {
    try {

        const res = await axios.get(apiUrl, {
          proxy: {
            host: proxy.hostname,
            port: proxy.port,
            auth: {
              username: proxy.auth.split(':')[0],
              password: proxy.auth.split(':')[1]
            }
          }
        });

        return res

    } catch (err) {
        console.error(err);
    }
};

export async function apiPostCall(apiUrl, body) {
    try {

        const res = await axios.post(apiUrl, body, {
          proxy: {
            host: proxy.hostname,
            port: proxy.port,
            auth: {
              username: proxy.auth.split(':')[0],
              password: proxy.auth.split(':')[1]
            }
          }
        });

        return res

    } catch (err) {
        console.error(err);
    }
};